import CyberRisklogo360 from "../assets/CyberRisklogo360.png";

export const AlmataMainLogo = "https://washi.s3.amazonaws.com/Almata-blue.png";
export const CyberRiskLogo360 = CyberRisklogo360;
export const FaviconAlmata = "../assets/almatalogobg.png";
export default {
    AlmataMainLogo,
    CyberRiskLogo360,
    FaviconAlmata
}